import { Component, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { ProfileComponent } from '../profile/profile.component';
import { MenuService } from '../side-menu/side-menu.service';

@Component({
  selector: 'app-header',
  imports: [ProfileComponent],
  templateUrl: './header.component.html',
})
export class HeaderComponent {
  menuService = inject(MenuService);

  title = 'Inicio';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.getDeepestTitle(this.activatedRoute)),
      )
      .subscribe((title) => (this.title = title));
  }

  private getDeepestTitle(route: ActivatedRoute): string {
    let activeRoute: ActivatedRoute | null = route;
    let lastTitle: string | undefined;

    while (activeRoute?.firstChild) {
      if (activeRoute.snapshot.data['title']) {
        lastTitle = activeRoute.snapshot.data['title']; // Guarda el título del padre
      }
      activeRoute = activeRoute.firstChild;
    }

    // Retorna el título del hijo más profundo si existe, sino usa el del padre
    return activeRoute?.snapshot.data['title'] || lastTitle || 'Aplicación';
  }
}
